import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l('<path fill="#FFDA44" d="M0 20c0 2.447.44 4.79 1.244 6.957L20 28.696l18.756-1.74A19.954 19.954 0 0 0 40 20c0-2.413-.427-4.726-1.21-6.867L20 11.303l-18.79 1.83A19.96 19.96 0 0 0 0 20Z"></path><path fill="#D80027" d="M20 40c8.6 0 15.93-5.427 18.756-13.043H1.244C4.07 34.573 11.401 40 20 40Z"></path><path fill="#6DA544" d="M20 0C11.4 0 4.07 5.428 1.244 13.044h37.512C35.93 5.428 28.6 0 20 0Z"></path><path fill="#0052B4" d="M20 29.565A9.565 9.565 0 0 0 29.565 20a9.565 9.565 0 0 0-19.13 0A9.565 9.565 0 0 0 20 29.565Z"></path><path fill="#FFDA44" d="m21.33 16.69-1.332-4.097-1.33 4.094-2.053-2.826-1.407 1.022 2.197 3.024h-4.726l3.385 2.457-2.949.959.538 1.654 3.321-1.08-1.503 4.619 3.66-2.663v3.103h1.739v-3.1l3.662 2.666-1.51-4.626 3.325 1.08.538-1.653-2.951-.96 3.387-2.456h-4.726l2.197-3.024-1.407-1.022-2.056 2.83Z"></path>', 5), a = [
  o
];
function c(i, p) {
  return t(), e("svg", h, [...a]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
